<template>
    <div class="block-promo" id="block-promo">
        <div class="block-promo__icon block-promo--mline-left">
            <img src="@/assets/images/icons/612-line-left-m.png">
        </div>
        <div class="block-promo__icon block-promo--mline-right">
            <img src="@/assets/images/icons/612-line-right-m.png">
        </div>
        <div class="block-promo__icon block-promo--five">
            <img src="@/assets/images/icons/612-five.png">
        </div>
        <div class="block-promo__icon block-promo--five-2 block-promo--icon-desktop">
            <img src="@/assets/images/icons/612-five.png">
        </div>
        <div class="block-promo__icon block-promo--five-green block-promo--icon-desktop">
            <img src="@/assets/images/icons/612-five-green.png">
        </div>
        <div class="block-promo__icon block-promo--1plus1 block-promo--icon-desktop">
            <img src="@/assets/images/icons/1plus1.png">
        </div>
        <div class="block-promo__icon block-promo--1plus1-2 block-promo--icon-desktop">
            <img src="@/assets/images/icons/1plus1.png">
        </div>
        <div class="block-promo__icon block-promo--1plus1-green block-promo--icon-desktop">
            <img src="@/assets/images/icons/1plus1-green.png">
        </div>
        <BlockParallax
            class="block-promo__icon block-promo--skate-one block-promo--icon-desktop"
            speed="5"
            transform="bypath"
            path="M 1.6267054,132.29166 C -2.9090096,96.761902 2.6428594,58.651649 36.400515,46.113092 62.858847,36.285713 78.355871,31.372022 88.939201,-1.0172526e-6"
            :options="{length: 250, scalePath: 3.4}"
            :offset="0"
            fixed
        >
            <img src="@/assets/images/icons/skate-1.png">
        </BlockParallax>
        <BlockParallax
            class="block-promo__icon block-promo--skate-two"
            speed="6"
            path="M 0.07785356,0.1069575 C 23.266691,16.985938 34.432305,37.506417 27.613418,68.579686 19.886211,103.79212 50.29199,132.45767 50.29199,132.45767"
            transform="bypath"
            :options="{length: 250, scalePath: 3.5}"
            :offset="100"
            fixed
        >
            <img src="@/assets/images/icons/skate-2.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--ball block-promo--icon-desktop" speed=".5" direction="left">
            <img src="@/assets/images/icons/ball.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--bag block-promo--icon-desktop" speed="6">
            <img src="@/assets/images/icons/bag.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--nb" speed="3">
            <img src="@/assets/images/icons/nb-2.png">
        </BlockParallax>
        <BlockParallax class="block-promo__icon block-promo--nb-two block-promo--icon-desktop" speed="5" direction="left">
            <img src="@/assets/images/icons/nb-2.png">
        </BlockParallax>
        <div class="main-wrap">
            <div class="block-promo__content">
                <p class="block-promo__title">6-12</p>
                <p class="block-promo__text">
                    Начальная школа, первые друзья в классе, пятерки и двойки, стихи наизусть. Наконец, долгожданное взросление и начало войны за самостоятельность.
                </p>
                <icon-arrow class="block-promo__arrow" v-scroll-to="'#block-info-three'" />
            </div>
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>


<style scoped lang="stylus">
    .block-promo {
        position relative
        background-color #66bd5a
        overflow hidden
        // background-image url('~@/assets/images/icons/line-white-mobile.png') ,
        // url('~@/assets/images/icons/car-mobile-1.png')
        background-repeat no-repeat
        background-position bottom 4px left, right top
        background-size 12rem, contain
        +layout-md-and-up() {
            position relative
            background-image url("~@/assets/images/icons/612-line-green-left.png")
            ,url('~@/assets/images/icons/612-white-line-left.png')
            ,url("~@/assets/images/icons/612-line-green-right.png")
            ,url("~@/assets/images/icons/612-white-line-right.png")
            background-position left 20% bottom, left 5% top, right 20% top, right top
            background-size contain, contain, contain, 30rem
        }

        &__content {
            position relative
            +layout-md-and-up() {
                display flex
                flex-direction column
                align-items center
                padding-bottom 5rem
            }
        }

        &__title {
            font-size 5.6rem
            color #FFFFFF
            font-weight 900
            letter-spacing 0.61px
            margin 2.7rem 0 0
            padding 0 0 0 5rem

            +layout-sm-and-up() {
                text-align center
                padding 0
            }
            +layout-md-and-up() {
                font-size 8rem
                letter-spacing 0.87px
                margin 12rem 0 0
                padding 0
            }
        }

        &__text {
            box-sizing border-box
            margin 0
            padding 2rem 2rem 13rem 5rem
            font-size 1.5rem
            line-height 1.47
            color #fff

            +layout-sm-and-up() {
                text-align center
                font-size 1.8rem
                line-height 2.8rem
                letter-spacing 0.19px
            }
            +layout-md-and-up() {
                width 100%
                max-width 63rem
                padding-bottom 0
                padding-top 2.1rem
            }
        }

        &__icon {
            position absolute
            max-width 100%
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &--ball {
            top 4rem
            right 0.8rem
            width 6.2rem
            transform rotate(65deg)
            +layout-md-and-up() {
                top 5rem
                right 9rem
                width 10rem
            }
        }

        &--bag {
            +layout-md-and-up() {
                width 15.2rem
                left 4rem
                top 18rem
            }
        }

        &--five {
            top 17rem
            left 2%
            width 5rem
            transform rotate(-15deg)
            img {
                max-width 100%
            }
            +layout-md-and-up() {
                display block
                top 15rem
                left 16rem
                // width 4rem
            }
        }
        
        &--mline-left {
            bottom 0
            left 0
            +layout-md-and-up() {
                display none
            }
        }
        &--mline-right {
            top 0
            right 0
            +layout-md-and-up() {
                display none
            }
        }
        
        &--five-2 {
            +layout-md-and-up() {
                display block
                bottom 10rem
                right 6rem
            }
        }
        &--five-green {
            +layout-md-and-up() {
                display block
                bottom 5rem
                right 38.7rem
            }
        }
        &--1plus1 {
            +layout-md-and-up() {
                display block
                bottom 7rem
                left 42rem
            }
        }
        &--1plus1-2 {
            display none
            +layout-md-and-up() {
                display block
                top 16rem
                right 22rem
                transform rotate(-45deg)
            }
        }
        &--1plus1-green {
            display none
            +layout-md-and-up() {
                display block
                bottom 3rem
                left 5rem
            }
        }

        &--nb {
            left .5%
            top 3.5rem
            transform rotate(-40deg)
            width 5.5rem
            +layout-md-and-up() {
                left 25rem
                top 2rem
                width 8.4rem
            }
        }

        &--nb-two {
            +layout-md-and-up() {
                width 10rem
                right 18rem
                bottom 11rem
            }
        }

        &__arrow {
            width 2rem
            position absolute
            right 0.6rem
            bottom 2rem
            animation translate 1.5s linear infinite forwards

            +layout-md-and-up() {
                position static
                padding-top 0
                margin-top 2rem
                padding-bottom 8.5rem
                cursor pointer

                &:hover {
                    fill $color-blue
                    cursor pointer
                    animation-play-state paused
                    opacity 0.7
                }
            }
        }

        &--skate-one {
            +layout-md-and-up() {
                display block
                top -2rem
                left 11%
            }
        }
        &--skate-two {
            bottom 4rem
            right 20%
            width 12rem
            transform rotate(-30deg)
            +layout-md-and-up() {
                display block
                width 17rem
                bottom auto
                top -2rem
                right 25%
                transform none
            }
        }
    }

</style>
